import { PostApi } from "../pages/DashBoard/partials/Feed/types/types";

/**
 * Fields for PUT /api/v1/feed/:id interaction updates (like / comment).
 * Never include publish_at / status — those 400 on published (ex-scheduled) posts.
 */
export const buildFeedPostUpdateFormData = (
  post: PostApi,
  overrides: { likes?: string; comments?: string } = {}
): FormData => {
  const formData = new FormData();

  formData.append("heading", post.heading ?? "");
  formData.append("content", post.content ?? "");
  formData.append(
    "likes",
    overrides.likes ??
      (typeof post.likes === "string"
        ? post.likes
        : JSON.stringify(post.likes ?? []))
  );
  formData.append(
    "comments",
    overrides.comments ??
      (typeof post.comments === "string"
        ? post.comments
        : JSON.stringify(post.comments ?? []))
  );
  if (post.images) {
    formData.append("images", post.images);
  }
  if (post.document_url) {
    formData.append("document_url", post.document_url);
  }
  if (post.main_type) {
    formData.append("main_type", post.main_type);
  }
  if (post.file_name) {
    formData.append("file_name", post.file_name);
  }

  return formData;
};
